/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Detail_Empty_All_BodyInputs */



/**
* | output |
* | --- |
* | "This partner has never closed a billing period." |
*
* @param {Partner_Detail_Empty_All_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_empty_all_body = /** @type {((inputs?: Partner_Detail_Empty_All_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Empty_All_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Partner hat noch nie einen Abrechnungszeitraum abgeschlossen.")
	return /** @type {LocalizedString} */ ("This partner has never closed a billing period.")
});